/**
 * Placement-test result screen.
 */
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import React from "react";
import { useTranslation } from 'react-i18next';

import { VText } from "form";

/**
 * Shows placement-test outcomes and recommended next steps.
 *
 * @param {{ answers?: Array }} props
 */
const PositionResult = (props) => {

  const { totalCount, successCount } = props;

  const { t } = useTranslation('common');

  return <Box className="w-full flex justify-center mt-8">
    <Box className="w-full max-w-xl">
      <Box className="shadow-lg mt-5 p-4 text-center">
        <Box className="fsp-18 mt-5">
          <Icon icon="bi:check-lg" className="mr-2" />
          <VText className="font-bold text-dark">{t('Your final score')}:</VText>&nbsp;
          <VText className="text-muted">{totalCount}&nbsp;{t('questions')}</VText>,&nbsp;
          <VText className="text-muted">
            
            {successCount}&nbsp;{t('correct answers')}
          </VText>&nbsp;
          <VText className="color-main3 text-xs px-2 py-1 bg-main2 rounded-full">
            {t('Entered')}
          </VText>
        </Box>
        <Box className="mt-5 text-2xl text-muted">
          {t('Thank you!')}
        </Box>
      </Box>


    </Box>
  </Box>
}

export default PositionResult;